import axios from "../axios-instance";
import {
  PlanManager_START,
  PlanManager_SUCCESS,
  PlanManager_FAIL,
  PlanManager_UPDATE_START,
  PlanManager_UPDATE_SUCCESS,
  PlanManager_UPDATE_FAIL,
  PlanManager_ACTION_START,
  PlanManager_ACTION_SUCCESS,
  PlanManager_ACTION_FAIL,
} from "../constants/planManager";

export const getPlanData = (id) => (dispatch) => {
  dispatch({ type: PlanManager_START });
  axios
    .get("super-admin/plans")
    .then((res) => {
      dispatch({
        type: PlanManager_SUCCESS,
        payload: res.data.data,
        planManagerData: res.data.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: PlanManager_FAIL,
        payload: err.response?.data?.data,
      })
    );
};

export const updatePlan = (planData, onSuccess) => (dispatch) => {
  dispatch({ type: PlanManager_UPDATE_START });
  axios
    .post("super-admin/plans/update", planData)
    .then((res) => {
      dispatch({ type: PlanManager_UPDATE_SUCCESS });
      if (onSuccess) onSuccess();
    })
    .catch((err) =>
      dispatch({
        type: PlanManager_UPDATE_FAIL,
        payload: err.response?.data?.data,
      })
    );
};

const extractError = (err) =>
  err.response?.data?.message ||
  err.response?.data?.data?.message ||
  "Something went wrong. Please try again.";

export const createPlan = (planData, onSuccess, onError) => (dispatch) => {
  dispatch({ type: PlanManager_ACTION_START });
  axios
    .post("super-admin/plans/create", planData)
    .then(() => {
      dispatch({ type: PlanManager_ACTION_SUCCESS });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      dispatch({ type: PlanManager_ACTION_FAIL });
      if (onError) onError(extractError(err));
    });
};

export const deletePlan = (id, onSuccess, onError) => (dispatch) => {
  dispatch({ type: PlanManager_ACTION_START });
  axios
    .post("super-admin/plans/delete", { id })
    .then(() => {
      dispatch({ type: PlanManager_ACTION_SUCCESS });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      dispatch({ type: PlanManager_ACTION_FAIL });
      if (onError) onError(extractError(err));
    });
};

export const togglePlanStatus = (id, onSuccess, onError) => (dispatch) => {
  dispatch({ type: PlanManager_ACTION_START });
  axios
    .post("super-admin/plans/toggle-status", { id })
    .then(() => {
      dispatch({ type: PlanManager_ACTION_SUCCESS });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      dispatch({ type: PlanManager_ACTION_FAIL });
      if (onError) onError(extractError(err));
    });
};
